import { gql } from "@apollo/client";



// 司机信息类型
export interface DriverType {
    accountId: number;
    name: string;
    phone: string;
    driverLicenseNumber: string;
    vehiclePlate: string;
    isBlacklist: boolean;
    isOnDuty: boolean;
    dspId: number;
    verificationStatus: number;
    status: number; // 账户状态：0=禁用, 1=启用
    isEmployed: boolean; // 是否在职：false=离职, true=在职
}





// 获取司机列表查询
export const GET_DRIVER_LIST_FOR_DSP = gql`
    query GetDriverListForDsp {
        getDriverListForDsp {
            accountId
            name
            phone
            driverLicenseNumber
            vehiclePlate
            isOnDuty
            dspId
        }
    }
`;

// 根据 DSP ID 列表查询司机
export const FIND_DRIVERS_BY_DSP_IDS = gql`
    query FindDriversByDspIds($dspIds: [Long!]!) {
        findDriversByDspIds(dspIds: $dspIds) {
            accountId
            name
            phone
            driverLicenseNumber
            vehiclePlate
            isBlacklist
            isOnDuty
            dspId
            verificationStatus
            status
            isEmployed
        }
    }
`;

// 获取司机列表响应类型
export interface GetDriverListResponse {
    getDriverListForDsp: DriverType[];
}

// 根据 DSP ID 查询司机响应类型
export interface FindDriversByDspIdsResponse {
    findDriversByDspIds: DriverType[];
}

// DSP ID 查询变量类型
export interface FindDriversByDspIdsVariables {
    dspIds: number[];
}
